var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

var TextContainer = function (_React$PureComponent) {
  _inherits(TextContainer, _React$PureComponent);

  function TextContainer() {
    _classCallCheck(this, TextContainer);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  TextContainer.prototype.render = function render() {
    var _props = this.props,
        idyll = _props.idyll,
        children = _props.children,
        className = _props.className,
        hasError = _props.hasError,
        updateProps = _props.updateProps,
        props = _objectWithoutProperties(_props, ['idyll', 'children', 'className', 'hasError', 'updateProps']);

    var _idyll$layout = idyll.layout,
        styles = _idyll$layout.styles,
        layout = _objectWithoutProperties(_idyll$layout, ['styles']);

    var _idyll$theme = idyll.theme,
        _ = _idyll$theme.styles,
        theme = _objectWithoutProperties(_idyll$theme, ['styles']);

    var cn = (className || '') + ' idyll-text-container';
    return React.createElement(
      'div',
      _extends({}, props, { className: cn }),
      children
    );
  };

  return TextContainer;
}(React.PureComponent);

TextContainer._idyll = {
  name: "TextContainer",
  tagType: "open"
};
export default TextContainer;